module.exports = __webpack_public_path__ + "img/ic_plus_white.6968d630.svg";